import { render, staticRenderFns } from "./QuestionPlansTable.vue?vue&type=template&id=69267768&"
import script from "./QuestionPlansTable.vue?vue&type=script&lang=js&"
export * from "./QuestionPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports